/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Try_For_FreeInputs */

const en_btn_try_for_free = /** @type {(inputs: Btn_Try_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try for FREE`)
};

const ar_btn_try_for_free = /** @type {(inputs: Btn_Try_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جرّب مجانًا`)
};

const de_btn_try_for_free = /** @type {(inputs: Btn_Try_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos testen`)
};

const es_btn_try_for_free = /** @type {(inputs: Btn_Try_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pruébalo gratis`)
};

const fr_btn_try_for_free = /** @type {(inputs: Btn_Try_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essai gratuit`)
};

const it_btn_try_for_free = /** @type {(inputs: Btn_Try_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provalo gratis`)
};

const ja_btn_try_for_free = /** @type {(inputs: Btn_Try_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料で試す`)
};

const ko_btn_try_for_free = /** @type {(inputs: Btn_Try_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료로 체험하기`)
};

const pt_br_btn_try_for_free = /** @type {(inputs: Btn_Try_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimente grátis`)
};

const ru_btn_try_for_free = /** @type {(inputs: Btn_Try_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробовать бесплатно`)
};

const th_btn_try_for_free = /** @type {(inputs: Btn_Try_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทดลองใช้ฟรี`)
};

const tr_btn_try_for_free = /** @type {(inputs: Btn_Try_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz dene`)
};

const zh_cn_btn_try_for_free = /** @type {(inputs: Btn_Try_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费体验`)
};

const zh_tw_btn_try_for_free = /** @type {(inputs: Btn_Try_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費體驗`)
};

/**
* | output |
* | --- |
* | "Try for FREE" |
*
* @param {Btn_Try_For_FreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_try_for_free = /** @type {((inputs?: Btn_Try_For_FreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Try_For_FreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_try_for_free(inputs)
	if (locale === "ar") return ar_btn_try_for_free(inputs)
	if (locale === "de") return de_btn_try_for_free(inputs)
	if (locale === "es") return es_btn_try_for_free(inputs)
	if (locale === "fr") return fr_btn_try_for_free(inputs)
	if (locale === "it") return it_btn_try_for_free(inputs)
	if (locale === "ja") return ja_btn_try_for_free(inputs)
	if (locale === "ko") return ko_btn_try_for_free(inputs)
	if (locale === "pt_br") return pt_br_btn_try_for_free(inputs)
	if (locale === "ru") return ru_btn_try_for_free(inputs)
	if (locale === "th") return th_btn_try_for_free(inputs)
	if (locale === "tr") return tr_btn_try_for_free(inputs)
	if (locale === "zh_cn") return zh_cn_btn_try_for_free(inputs)
	return zh_tw_btn_try_for_free(inputs)
});